import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as PeopleActions from 'web-app/react/institution-people/people/actions';
import {updateReferenceMap} from 'web-app/react/entities/factory/reducer-factory';
import * as StatusActions from 'web-app/react/entities/statuses/actions';
import * as LeaveRegistrationActions from 'web-app/react/profile/child-profile/leave-registration/actions';
import * as LeaveRegistrationConstants from 'web-app/react/profile/child-profile/leave-registration/constants';

import {GROUP_BY_KEYS} from './constants';

export default handleActions(
    {
        // this should probably not be needed anymore as the fetching of schedules is now
        // done via the graphql endpoint rather than the rest endpoint (which triggers this action)
        // As it is impossible to know where this status is used (yields quite some uses), let's leave it here.
        // Not used anymore for
        // - showing the full/part day leave times under the person button
        [LeaveRegistrationActions.updateSuccess.type]: (state, {payload}) => {
            if (payload.personType === LeaveRegistrationConstants.EMPLOYEE) {
                const newEntityMap = state.entityMap.mergeDeep({
                    [payload.personId]: new Map({
                        isSick: payload.leaveType === 'SICK',
                        isAbsent: payload.leaveType === 'ABSENT',
                        hasVacation: payload.leaveType === 'VACATION',
                        hasChildSick: payload.leaveType === 'CHILD_SICK',
                    }),
                });
                const newReferenceMap = updateReferenceMap(state.referenceMap, newEntityMap.toList(), GROUP_BY_KEYS);

                return state.merge({
                    entityMap: newEntityMap,
                    referenceMap: newReferenceMap,
                });
            }
            return state;
        },
        [StatusActions.endStatusSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.employeeIds.reduce((acc, employeeId) => {
                const employee = acc.get(employeeId);
                const updatedStatuses = employee.statusRegistrations.filter(
                    s => s.statusConfig.statusConfigId !== payload.statusConfigId,
                );
                const updatedEmployee = employee.merge({statusRegistrations: updatedStatuses});
                return acc.set(employeeId, updatedEmployee);
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
        [StatusActions.applyStatusSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.employeeIds.reduce((acc, employeeId) => {
                const employee = acc.get(employeeId);
                const newStatus = {statusConfig: {statusConfigId: payload.statusConfigId}};
                const updatedStatuses = employee.statusRegistrations.push(newStatus);
                const updatedEmployee = employee.merge({statusRegistrations: updatedStatuses});
                return acc.set(employeeId, updatedEmployee);
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
        [PeopleActions.checkinSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.employeesIds.reduce((acc, employeeId) => {
                const employee = acc.get(employeeId);
                const updatedValues = {checkedIn: true};
                return acc.set(employeeId, employee.merge(updatedValues));
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
        [PeopleActions.createEmployeeSuccess.type]: (state, {payload}) => {
            const newEntityMap = state.entityMap.set(payload.employee.id, payload.employee);
            const newReferenceMap = updateReferenceMap(state.referenceMap, newEntityMap.toList(), GROUP_BY_KEYS);

            return state.merge({
                entityMap: newEntityMap,
                referenceMap: newReferenceMap,
            });
        },
        [PeopleActions.checkoutSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.employeesIds.reduce((acc, employeeId) => {
                const employee = acc.get(employeeId);
                const updatedValues = {checkedIn: false, behaviors: []};
                return acc.set(employeeId, employee.merge(updatedValues));
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
    },
    null,
);
